var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2508 4121 c-15 -5 -42 -18 -60 -30 -46 -28 -711 -709 -732 -748 -9 -18 -16 -55 -16 -86 0 -109 78 -196 184 -205 95 -8 116 5 293 181 l163 161 2 -916 3 -916 30 -43 c17 -23 50 -53 75 -66 38 -21 56 -24 121 -21 95 4 145 34 184 111 l25 51 0 895 0 895 154 -152 c88 -88 169 -158 190 -167 72 -30 180 -13 234 38 61 56 82 168 46 239 -25 48 -700 736 -746 759 -45 23 -112 32 -150 20z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/up.d6384df901df5a82d2c2848cfaa8713d.svg";
export { ForwardRef as ReactComponent };